"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyReferralStatsInputs = [
  {
    name: "heading",
    type: "string",
    required: true,
    defaultValue: "Your Referral Stats",
  },
  {
    name: "subHeading",
    type: "string",
    required: true,
    defaultValue: "Track your progress",
  },
  {
    name: "friendsReferredDescription",
    type: "string",
    friendlyName: "Description",
    required: true,
    defaultValue: "Friends Referred",
  },
  {
    name: "friendsReferredInfoHeading",
    type: "string",
    required: true,
    friendlyName: "Info Heading",
    defaultValue: "Referrals Info",
  },
  {
    name: "friendsReferredPoints",
    type: "string",
    required: true,
    friendlyName: "Points",
    defaultValue: "Points per Referral",
  },
  {
    name: "friendsReferredSubText",
    type: "string",
    required: true,
    friendlyName: "Sub Text",
    defaultValue: "Description",
  },
  {
    name: "pointsEarnedDescription",
    type: "string",
    required: true,
    defaultValue: "Points Earned",
  },
  {
    name: "pointsEarnedCtaLink",
    type: "string",
    required: true,
    defaultValue: "#",
  },
  {
    name: "pointsEarnedCtaText",
    type: "string",
    required: true,
    defaultValue: "View Rewards",
  },
  {
    name: "nextTierInfoDescription",
    type: "string",
    required: true,
    defaultValue: "Next Tier Info",
  },
  {
    name: "nextTierInfoCtaLink",
    type: "string",
    required: true,
    defaultValue: "/tiers",
  },
  {
    name: "nextTierInfoCtaText",
    type: "string",
    required: true,
    defaultValue: "Learn More",
  },
  {
    name: "progressBlockBg",
    type: "file",
    required: true,
    friendlyName: "Progress Block Desktop Background",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "progressBlockBgTablet",
    type: "file",
    required: true,
    friendlyName: "Progress Block Tablet Background",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "progressBlockBgMobile",
    type: "file",
    required: true,
    friendlyName: "Progress Block Mobile Background",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "progressBlockHeading",
    type: "string",
    required: true,
    defaultValue: "Keep Going!",
  },
  {
    name: "progressBlockDescription",
    type: "string",
    required: true,
    defaultValue: "You're almost there.",
  },
  {
    name: "progressBlockHeadingAllDone",
    type: "string",
    required: true,
    defaultValue: "All Done!",
  },
  {
    name: "progressBlockDescriptionAllDone",
    type: "string",
    required: true,
    defaultValue: "You've achieved everything.",
  },
  {
    name: "progressBarText",
    type: "string",
    required: true,
    defaultValue: "Progress",
  },
  {
    name: "milestonesText",
    type: "string",
    required: true,
    defaultValue: "Milestones",
  },
  {
    name: "achievementsDoneHeading",
    type: "string",
    required: true,
    defaultValue: "Congratulations!",
  },
  {
    name: "achievementsDoneText",
    type: "string",
    required: true,
    defaultValue: "You've unlocked all milestones.",
  },
  {
    name: "isStatsVisible",
    type: "boolean",
    required: true,
    friendlyName: "Show statistics",
    defaultValue: true,
  },
  {
    name: "isAnimatedNumberEnabled",
    type: "boolean",
    friendlyName: "Enable animation for user points number",
    defaultValue: false,
  },
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark"],
    defaultValue: "light",
  },
  {
    name: "milestones",
    type: "list",
    required: true,
    defaultValue: [],
    subFields: [
      { name: "referralNumber", type: "number", required: true },
      { name: "mileStonePointsValue", type: "number", required: true },
    ],
  },
] as const satisfies Inputs;

export const LoyaltyReferralStatsComponent: RegisteredComponent = {
  name: "LoyaltyReferralStatsDashboard",
  component: dynamic(async () =>
    withValidation(
      loyaltyReferralStatsInputs,
      (await import("./LoyaltyReferralStats")).LoyaltyReferralStats,
      "LoyaltyReferralStatsDashboard"
    )
  ),
  inputs: loyaltyReferralStatsInputs,
};
